export const chat = {
  list: {
    title: "メッセージ",
    tabAll: "全員",
    tabActive: "会話中",
    tabBookmark: "お気に入り",
    edit: "編集",
    done: "完了",
    markAllRead: "全て既読",
    deleteAll: "全て削除",
    empty: "会話がありません",
    imageSent: "画像を送信しました",
    imageReceived: "画像が届きました",
    videoSent: "動画を送信しました",
    videoReceived: "動画が届きました",
    mediaMark: "メディアあり",
    audioSent: "ボイスメッセージを送信しました",
    audioReceived: "ボイスメッセージが届きました",
    stickerSent: "スタンプを送信しました",
    stickerReceived: "スタンプが届きました",
    confirmMarkAllReadTitle: "全て既読にしますか？",
    confirmMarkAllReadDescription: "全ての会話を既読にします。",
    confirmMarkRead: "既読にする",
    confirmDeleteAllTitle: "全て削除しますか？",
    confirmDeleteAllDescription:
      "全ての会話を削除します。この操作は取り消せません。",
    confirmDelete: "削除する",
    allShown: "すべて表示しました",
    markAllReadError:
      "既読処理に失敗しました。時間をおいて再度お試しください。",
    deleteAllError: "削除に失敗しました。時間をおいて再度お試しください。",
  },
  room: {
    placeholder: "相手のことをほめてみよう",
    send: "送信",
    callStarted: "通話を開始しました",
    callEnded: "通話が終了しました",
    missedCall: "不在着信",
    callCancelled: "発信キャンセル",
    callBack: "タップでかけ直す",
    videoCall: "ビデオ通話",
    voiceCall: "音声通話",
    loadEarlier: "過去のメッセージを読み込む",
    messageSend: "メッセージ送信",
    sendError: "送信に失敗しました",
    retry: "再送信",
    selectMedia: "画像・動画を選択",
    selectSticker: "スタンプを選択",
    closePanel: "パネルを閉じる",
    sticker: "スタンプ",
    stickerCategory: (args: { number: string | number }) =>
      `スタンプカテゴリ${args.number}`,
    stickerItem: (args: { number: string | number }) =>
      `スタンプ${args.number}`,
    confirmSendMedia: "この画像/動画を送信しますか？",
    image: "画像",
    video: "動画",
    viewImage: "画像を見る",
    viewVideo: "動画を見る",
    audio: "音声",
    block: "ブロックする",
    report: "通報する",
    blockSuccess: (args: { name: string | number }) =>
      `${args.name} をブロックしました`,
    reportSuccess: "通報しました",
    likePrompt: "気になったらいいねを送ろう",
    likeButton: "いいね！",
    introShowMore: "もっと見る",
    read: "既読",
    viewAllPhotos: "すべて見る",
    viewImages: "画像・動画一覧",
    mediaGalleryTitle: "送信された画像・動画",
    noMedia: "送信された画像・動画はありません",
    viewOtherGirls: "他の女の子の画像・動画見たい方はこちら",
    callFeeLabel: "通話料金",
    heldPointLabel: "保有ポイント",
    heldPointValue: (args: { point: string | number }) => `${args.point}P`,
    ratePerMinute: (args: { point: string | number }) => `${args.point}P / 分`,
    startCall: (args: { type: string | number }) => `${args.type}を発信`,
    requestCall: (args: { type: string | number }) =>
      `${args.type}をリクエスト`,
    callNotAccepting: "相手は通話を受け付けていません",
    voiceCallComingSoon: "音声通話は準備中です",
  },
} as const;
